module.exports = __webpack_public_path__ + "img/kao_yan.e2079503.png";